<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <span>出款配置</span>
        </Card>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'payManage/withdrawConfig/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="130"
            label-position='left'>
        <FormItem label='名称' prop='title' style="margin-bottom: 4px">
          <Input v-model='windowAddItem.title' :placeholder="$t('请输入名称')"></Input>
        </FormItem>


        <FormItem label='支持币种' prop='support_coin_exchange_ids' style="margin-bottom: 4px">
          <CheckboxGroup style="display: inline-block;"
                         v-model="windowAddItem.support_coin_exchange_ids">
            <Checkbox :key="key" :label="value.id"
                      v-for="(value, key) in windowAdd.windowsParams.coinExchangeArray"> {{ value.currency }}
            </Checkbox>
          </CheckboxGroup>
        </FormItem>

        <div style="border-bottom: 1px solid dodgerblue;padding-bottom:10px;margin-bottom: 20px"></div>
        <FormItem label='通道类型' :prop="setting_pay_channel_id" style="margin-bottom: 4px">
          <Select v-model="windowAddItem.setting_pay_channel_id" @on-change="windowSelectChange" style='width:200px'>
            <Option key="key" :value="value.id" v-for="(value, key) in windowAdd.windowsParams.settingPayChannelArray">
              {{ value.pay_name }}
            </Option>
          </Select>
        </FormItem>

        <FormItem style="margin-bottom: 4px" :label='value.name' :prop="key"
                  v-for="(value, key) in  windowAdd.windowsParams2">

          <div v-if="value.type=='image'"> <!--如果是图片类型-->
            <div class="demo-upload-list" v-if="windowAddItem[key]">
              <img :src="windowAddItem[key]" style="max-width: 600px;max-height: 600px">
              <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="handleImgRemove(key)"></Icon>
              </div>
            </div>
            <input v-if="windowAddItem[key]" v-model="windowAddItem[key]" type="hidden" name="image">
            <Upload type="drag"
                    :action="uploadUrl"
                    :headers="uploadHeader"
                    v-if="!windowAddItem[key]"
                    :format="['jpg','jpeg','png','gif']"
                    :max-size="5120"
                    :on-success="handleImgSuccess"
                    :on-format-error="handleImgFormatError"
                    :on-exceeded-size="handleImgMaxSize"
                    style="display: inline-block;width:58px">
              <div style="width: 58px;height:58px;line-height: 58px">
                <Icon type="md-camera" size="20"></Icon>
              </div>
            </Upload>
          </div>

          <Input v-else-if="!value.option" :key="key" v-model="windowAddItem[key]" :placeholder="value.name"></Input>
          <!--如果是没有其它选项是输入框-->

          <Select v-else v-model="windowAddItem[key]" style='width:200px'><!--如果是有其它选项是选项框-->
            <Option key="k" :value="k" v-for="(v, k) in value.option"> {{ v }}
            </Option>
          </Select>
        </FormItem>

        <div style="border-bottom: 1px solid dodgerblue;padding-bottom:10px;margin-bottom: 20px"></div>
        <FormItem style="margin-bottom: 4px" label='最高提现金额' prop='max_money'>
          <InputNumber v-model='windowAddItem.max_money' :placeholder="$t('请输入最高充值金额')"></InputNumber>
        </FormItem>
        <FormItem style="margin-bottom: 4px" label='最低提现金额' prop='min_money'>
          <InputNumber v-model='windowAddItem.min_money' :placeholder="$t('请输入最低充值金额')"></InputNumber>
        </FormItem>


        <FormItem style="margin-bottom: 4px" label='排序' prop='sort'>
          <InputNumber v-model='windowAddItem.sort' :placeholder="$t('请输入排序')"></InputNumber>
        </FormItem>

        <FormItem style="margin-bottom: 4px" label='备注' prop='remark'>
          <Input v-model='windowAddItem.remark' :placeholder="$t('请输入备注')"></Input>
        </FormItem>


        <FormItem style="margin-bottom: 4px" label='状态' prop='is_lock'>
          <Select v-model='windowAddItem.is_lock' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('正常') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('锁定') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getWindowsParams
} from '@/api/payManage/withdrawConfig'
import { getToken } from '@/libs/util'
import { baseUrl } from '@/libs/api.request'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: { 'Api-Auth': getToken() },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('名称'),
        key: 'title',
        width: 100,
        align: 'center'
      }, {
        title: this.$t('详情'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('通道类型') + ':' + params.row.pay_name), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('支持货币') + ':' + params.row.support_coin_exchange_ids_name), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('添加时间') + ':' + params.row.add_time),])
        }
      }, {
        title: this.$t('是否启用'),
        align: 'center',
        width: 60,
        key: 'is_lock',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_lock ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_lock ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_lock ? this.$t('锁定') : this.$t('正常')),
          ])
        }
      }, {
        title: this.$t('备注'),
        align: 'center',
        width: 130,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('最大充值') + ':' + params.row.max_money), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('最小充值') + ':' + params.row.min_money), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('修改人') + ':' + params.row.admin_name), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('备注') + ':' + params.row.remark),])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        width: 100,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem.support_coin_exchange_ids = []
                vm.windowAddItem.see_level = []
                vm.windowAddItem.open_grade = []
                vm.windowAddItem.recharge_send_level = []
                if (!vm.windowAdd.windowsParams.coinExchangeArray) {
                  getWindowsParams().then(response => {
                    vm.windowAdd.windowsParams = response.data.data
                    this.setWindowsParams()
                    for (var key in vm.windowAdd.windowsParams.settingPayChannelArray) {
                      if (vm.windowAdd.windowsParams.settingPayChannelArray[key]['id'] == params.row.setting_pay_channel_id) {
                        this.windowAdd.windowsParams2 = vm.windowAdd.windowsParams.settingPayChannelArray[key].config
                      }
                    }
                    vm.windowAddItem.support_coin_exchange_ids = params.row.support_coin_exchange_ids.split(',').map(Number)
                    vm.windowAddItem.see_level = params.row.see_level.split(',').map(Number)
                    vm.windowAddItem.open_grade = params.row.open_grade.split(',').map(Number)
                    vm.windowAddItem.recharge_send_level = params.row.recharge_send_level.split(',').map(Number)
                  })
                }
                vm.windowAddItem.id = params.row.id
                vm.windowAddItem.support_coin_exchange_ids = params.row.support_coin_exchange_ids.split(',').map(Number)
                vm.windowAddItem.see_level = params.row.see_level.split(',').map(Number)
                vm.windowAddItem.open_grade = params.row.open_grade.split(',').map(Number)
                vm.windowAddItem.recharge_send_level = params.row.recharge_send_level.split(',').map(Number)
                //vm.windowAddItem.see_level=[1,2,3,4,5,6,7,8,9];
                //vm.windowAddItem.open_grade=[1,2,3,4,5,6,7,8,9,10];
                //vm.windowAddItem.recharge_send_level=[1,2,3,4,5,6,7,8,9,10];
                vm.windowAddItem.title = params.row.title
                vm.windowAddItem.sort = params.row.sort
                vm.windowAddItem.max_money = params.row.max_money
                vm.windowAddItem.min_money = params.row.min_money
                vm.windowAddItem.dama_normal = params.row.dama_normal
                vm.windowAddItem.recharge_send_dama = params.row.recharge_send_dama
                vm.windowAddItem.is_lock = params.row.is_lock.toString()
                vm.windowAddItem.setting_pay_channel_id = params.row.setting_pay_channel_id.toString()
                vm.windowAddItem.risk_type = params.row.risk_type.toString()
                vm.windowAddItem.recharge_send_type = params.row.recharge_send_type.toString()
                vm.windowAddItem.recharge_send = params.row.recharge_send.toString()
                vm.windowAddItem.remark = params.row.remark
                vm.windowAddItem.risk_money = params.row.risk_money
                vm.windowAddItem.setting_pay_channel_id = params.row.setting_pay_channel_id
                vm.windowAddItem.p1 = params.row.p1
                vm.windowAddItem.p2 = params.row.p2
                vm.windowAddItem.p3 = params.row.p3
                vm.windowAddItem.p4 = params.row.p4
                vm.windowAddItem.p5 = params.row.p5
                vm.windowAddItem.p6 = params.row.p6
                vm.windowAddItem.p7 = params.row.p7
                vm.windowAddItem.p8 = params.row.p8
                vm.windowAddItem.p9 = params.row.p9
                vm.windowAddItem.p10 = params.row.p10

                for (var key in vm.windowAdd.windowsParams.settingPayChannelArray) {
                  if (vm.windowAdd.windowsParams.settingPayChannelArray[key]['id'] == params.row.setting_pay_channel_id) {
                    this.windowAdd.windowsParams2 = vm.windowAdd.windowsParams.settingPayChannelArray[key].config
                  }
                }

                vm.windowAdd.show = true
              }
            }
          }, this.$t('修改')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('确定要修改?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                lock(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                  this.getList()
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('info'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, !params.row.is_lock ? this.$t('锁定') : this.$t('解锁'))
          ]), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ]),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0,
        windowsParams: {},
        windowsParams2: {},
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        see_level: [],
        open_grade: [],
        recharge_send_level: [],
        support_coin_exchange_ids: [],
        risk_type: '1',
        recharge_send: '1',
        p1: '',
        p2: '',
        p3: '',
        p4: '',
        p5: '',
        p6: '',
        p7: '',
        p8: '',
        p9: '',
        p10: '',
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('payManage/withdrawConfig/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('payManage/withdrawConfig/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('payManage/withdrawConfig/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAddItem.support_coin_exchange_ids = []
      vm.windowAddItem.see_level = []
      vm.windowAddItem.open_grade = []
      vm.windowAddItem.recharge_send_level = []
      if (!vm.windowAdd.windowsParams.coinExchangeArray) {
        getWindowsParams().then(response => {
          vm.windowAdd.windowsParams = response.data.data
          this.setWindowsParams()
        })
      }
      this.setWindowsParams()
      // vm.windowAddItem.support_coin_exchange_ids=[1,2,3,4,5,6,7,8,9,10];
      //vm.windowAddItem.see_level=[1,2,3,4,5,6,7,8,9];
      //vm.windowAddItem.open_grade=[1,2,3,4,5,6,7,8,9,10];
      vm.windowAddItem.id = 0
      vm.windowAddItem.sort = 10
      vm.windowAddItem.max_money = 1000000
      vm.windowAddItem.min_money = 10
      vm.windowAddItem.dama_normal = 100
      vm.windowAddItem.recharge_send_dama = 100
      vm.windowAddItem.is_lock = '0'
      vm.windowAddItem.setting_pay_channel_id = ''
      vm.windowAddItem.risk_type = '1'
      vm.windowAddItem.recharge_send = '1'
      vm.windowAdd.windowsParams2 = ''
      vm.windowAddItem.title = ''
      vm.windowAddItem.recharge_send_type = '1'
      vm.windowAddItem.remark = ''
      vm.windowAddItem.risk_money = ''
      vm.windowAddItem.p1 = ''
      vm.windowAddItem.p2 = ''
      vm.windowAddItem.p3 = ''
      vm.windowAddItem.p4 = ''
      vm.windowAddItem.p5 = ''
      vm.windowAddItem.p6 = ''
      vm.windowAddItem.p7 = ''
      vm.windowAddItem.p8 = ''
      vm.windowAddItem.p9 = ''
      vm.windowAddItem.p10 = ''
      vm.windowAdd.show = true
    },
    setWindowsParams () {
      let vm = this
      for (var key in vm.windowAdd.windowsParams.coinExchangeArray) {
        var id = vm.windowAdd.windowsParams.coinExchangeArray[key]['id']
        vm.windowAddItem.support_coin_exchange_ids.push(id)
      }
      for (var key in vm.windowAdd.windowsParams.gradeArray) {
        var id = vm.windowAdd.windowsParams.gradeArray[key]['grade_key']
        vm.windowAddItem.open_grade.push(id)
      }
      for (var key in vm.windowAdd.windowsParams.levelArray) {
        var id = vm.windowAdd.windowsParams.levelArray[key]['level_number']
        if (id != 0) {//0是黑名单
          vm.windowAddItem.see_level.push(id)
          vm.windowAddItem.recharge_send_level.push(id)
        }
      }
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    windowSelectChange (pay_id) {
      let vm = this
      console.log(pay_id)
      for (var key in vm.windowAdd.windowsParams.settingPayChannelArray) {
        if (vm.windowAdd.windowsParams.settingPayChannelArray[key]['id'] == pay_id) {
          this.windowAdd.windowsParams2 = vm.windowAdd.windowsParams.settingPayChannelArray[key].config
        }
      }
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
    handleImgFormatError (file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove (key) {
      this.windowAddItem[key] = ''
    },
    handleImgSuccess (response) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        //this.windowAddItem.image = response.data.fileUrl
        //由于字段是动态的，所以查找一下 图片字段，再显示
        for (let key in this.windowAdd.windowsParams2) {
          if (this.windowAdd.windowsParams2[key]['type'] == 'image') {
            this.windowAddItem[key] = response.data.fileUrl
          }
        }

      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize (file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },
  }
}
</script>
